module.exports = __webpack_public_path__ + "static/media/BW.79c563a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BW.svg
// module id = 213
// module chunks = 0